/** PROTOTYPE generic centered modal -- THROWAWAY. Overlay + panel + header + Done footer. */
import React from 'react';
import { CRC } from './moduleInputsData';

interface Props { title: string; subtitle?: string; onClose: () => void; children: React.ReactNode; }

export const SpreadModal: React.FC<Props> = ({ title, subtitle, onClose, children }) => (
  <div style={{ position: 'fixed', inset: 0, zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
    <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(0,39,63,0.25)' }} />
    <div style={{ position: 'relative', width: 'min(680px, 100%)', maxHeight: '85vh', background: '#fff', borderRadius: 14, boxShadow: '0 12px 40px rgba(0,39,63,0.22)', display: 'flex', flexDirection: 'column', fontFamily: 'Montserrat, sans-serif' }}>
      <div style={{ padding: '18px 22px 14px', borderBottom: `1px solid ${CRC.border}` }}>
        <div style={{ fontFamily: 'Funnel Sans', fontSize: 16, fontWeight: 600, color: CRC.blueprintBlue }}>{title}</div>
        {subtitle && <div style={{ fontSize: 11.5, color: CRC.heritageGrey, marginTop: 3 }}>{subtitle}</div>}
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '18px 22px', display: 'flex', flexDirection: 'column', gap: 18 }}>
        {children}
      </div>
      <div style={{ padding: '14px 22px', borderTop: `1px solid ${CRC.border}`, display: 'flex', justifyContent: 'flex-end' }}>
        <button onClick={onClose} style={{ padding: '8px 18px', background: CRC.heroRed, color: '#fff', border: 'none', borderRadius: 8, fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>Done</button>
      </div>
    </div>
  </div>
);
